import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const DisplayCardContainer = styled('div')<{ theme?: TTheme }>`
    padding: 20px;
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    height: 100%;
`
